import { PlannerBundle } from 'pages/planner/utils/usePlannerData';
import React, { Fragment } from 'react';
import { BundleStatus } from 'types/bundleTypes';

interface BundleCheckboxStatus {
  name: string;
  values: Array<BundleStatus>;
}

interface PlannerFilterBundleStatusProps {
  bundles: PlannerBundle[];
  availableStatuses: Array<BundleCheckboxStatus>;
  selectedStatuses: Array<BundleStatus>;
  onChange: (newBundleStatuses: Array<BundleStatus>) => void;
  onClearAllFilters: () => void;
}

export const PlannerFilterBundleStatus = ({
  bundles,
  availableStatuses,
  selectedStatuses,
  ...props
}: PlannerFilterBundleStatusProps) => {
  const countBundle = (checkboxStatus: BundleCheckboxStatus) => {
    return bundles.filter(bundle =>
      checkboxStatus.values.includes(bundle.status)
    ).length;
  };

  const isStatusExist = (
    statuses: Array<BundleStatus>,
    comparatorStatuses: Array<BundleStatus>
  ) => {
    const isExist = (comparator: BundleStatus) => {
      return statuses.includes(comparator);
    };

    return comparatorStatuses.some(isExist);
  };

  const onFilterChange = (status: BundleCheckboxStatus, index: number) => {
    let newSelectedStatus = [];

    const chosenStatusHasBeenSelected = isStatusExist(
      status.values,
      selectedStatuses
    );

    if (chosenStatusHasBeenSelected) {
      /* Remove from selected */
      newSelectedStatus = selectedStatuses.filter(
        selectedStatus => !status.values.includes(selectedStatus)
      );
    } else {
      /* Add to selected */
      newSelectedStatus = [...selectedStatuses, ...status.values];
    }

    props.onChange(newSelectedStatus);
  };

  return (
    <div className="bundle-status">
      <div className="bundle-header">
        <strong>Bundle status</strong>
        <button className="button" onClick={props.onClearAllFilters}>
          Clear all filters
        </button>
      </div>
      <div className="tools-line" />
      <div className="bundle-checkbox">
        {availableStatuses.map((availableStatus, statusIndex) => (
          <Fragment key={`bundle-status-checkbox-${statusIndex}`}>
            <label>
              <input
                type="checkbox"
                onChange={() => onFilterChange(availableStatus, statusIndex)}
                checked={isStatusExist(
                  availableStatus.values,
                  selectedStatuses
                )}
              />
              {availableStatus.name} ({countBundle(availableStatus)})
            </label>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
